<template>
  <div class="flex w-full flex-col gap-24">
    <div class="w-full flex flex-col">
      <TypographyH1
        v-if="!isMobileScreenSize"
        class="font-semibold text-3xl w-full"
      >
        {{ title }}
      </TypographyH1>
      <TypographyH2 v-else class="font-semibold w-full text-lg">
        {{ title }}
      </TypographyH2>
      <TypographyBody v-if="description" class="w-full">
        {{ description }}
      </TypographyBody>
    </div>
    <slot class="w-full flex" />
    <div class="w-full flex flex-col gap-24">
      <div v-for="item in options" :key="item.title">
        <input
          :id="item.code"
          :name="title"
          :value="item.code"
          type="radio"
          :checked="modelValue === item.code"
          @change="$emit('update:modelValue', item.code)"
        />
        <label :for="item.code">
          <TypographyBody class="pl-12 inline-block">
            {{ $t(item.title) }}
          </TypographyBody>
        </label>
      </div>
    </div>
    <slot name="footer" />
  </div>
</template>

<script>
import TypographyBody from '~/components/common/Typography/Body.vue'
import TypographyH1 from '~/components/common/Typography/H1.vue'
import TypographyH2 from '~/components/common/Typography/H2.vue'
import screenSizeMixin from '~/components/mixins/screenSizeMixin'

export default {
  components: {
    TypographyH1,
    TypographyH2,
    TypographyBody,
  },
  mixins: [screenSizeMixin],
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      required: true,
    },
    modelValue: {
      type: String,
      default: null,
    },
  },
}
</script>
